import { createFeatureSelector, createSelector } from '@ngrx/store';

const getCustomerDashboardState = createFeatureSelector('customerDashboard');

export const getCustomerDashboardData = createSelector(getCustomerDashboardState, (state: any) => state.data);
export const getCustomerOfferData = createSelector(getCustomerDashboardState, (state: any) => state.offerData);
